
export const eventTypes =  [
    {
        value               :   1,
        label               :   'Starting refills',
        parameters          :   'Volume of fuel filled'
    },
    {
        value               :   2,
        label               :   'End of refills',
        parameters          :   'Volume of fuel filled'
    },
    {
        value               :   3,
        label               :   'Draining (beginning)',
        parameters          :   'Volume of fuel drained'
    },
    {
        value               :   4,
        label               :   'Draining (end)',
        parameters          :   'Volume of fuel drained'
    },
    {
        value               :   5,
        label               :   'Ignition on',
        parameters          :   'Time elapsed since the ignition was turned of'
    },
    {
        value               :   6,
        label               :   'Ignition off',
        parameters          :   ''
    },
    {
        value               :   7,
        label               :   'Switching to the main power source',
        parameters          :   ''
    },
    {
        value               :   8,
        label               :   'Switching to a backup power source',
        parameters          :   ''
    }
];